<template>
	<div class="header">
        <div v-if="env == 'zhj'" class="logo">
            <!-- <el-image :src="require('@/assets/img/TgLogo.png')" style="height:33px;" fit="contain" /> -->
            <el-image :src="require('@/assets/img/ZhjLogo.png')" style="height:40px;" fit="contain" />
            <div class="logotext">智绘佳下单系统</div>
            <div class="logotext2">v{{version}}</div>
        </div>
        <div v-else class="logo">
            <el-image :src="require('@/assets/img/KfLogo.png')" style="height:100%;" fit="contain" />
            <div class="logotext">{{$t('科凡下单系统')}}</div>
            <div class="logotext2">v{{version}}</div>
        </div>

        <el-menu
            :default-active="activeIndex"
            class="menu"
            mode="horizontal"
            router
        >
            <template v-if="userType">
                <el-menu-item index="/OrderSystem">{{$t('订单系统')}}</el-menu-item>
                <el-menu-item index="/KuJiaLe" v-if="enableKJL">{{$t('酷家乐')}}</el-menu-item>
                <!-- <el-menu-item index="/ProcessMgt">流程</el-menu-item> -->
                <el-menu-item index="/Setting">{{$t('设置')}}</el-menu-item>
            </template>
            <template v-else>
                <el-menu-item index="/Login">{{$t('登录')}}</el-menu-item>
            </template>

            <!-- <template v-if="env == 'development'">
                <el-menu-item index="/AuditOrderSystem">审单系统</el-menu-item>
                <el-menu-item index="/LogSystem">系统日志</el-menu-item>
            </template> -->
        </el-menu>
        <div v-if="env == 'development'" class="other" style="width: max-content;gap: 5px;">
            <!-- <div>Language</div> -->
            <el-switch
                v-model="lang"
                size="large"
                active-text="简体中文"
                inactive-text="English"
                active-value="zh-cn"
                inactive-value="en"
                inline-prompt
                style="--el-switch-off-color: #13ce66"
                @change="onChangeLanguage"
            />
        </div>
        <div v-if="lang!='zh-cn'" class="other" style="width: max-content;">
            <!-- <el-link underline>设计学习网</el-link> -->
            <el-icon :size="24"><Download /></el-icon>
            <span @click="onDownloadKjlTranslatePlugin">
                Translate Plugin
            </span>
        </div>
        <div class="other" style="width: max-content;">
            <!-- <el-link underline>设计学习网</el-link> -->
            <el-icon :size="24"><Link/></el-icon>
            <span @click="openHelpWebsite">
                {{$t('设计学习网')}}
            </span>
        </div>
        <div class="user">
            <el-avatar :size="40" class="user_avatar">
                <el-image v-if="enableKJL" :src="userKJL.UserAvatar"></el-image>
                <el-icon v-else><User /></el-icon>
            </el-avatar>
            
            <el-popover v-if="false" placement="bottom-end" trigger="click" effect="dark" :popper-style="userPannelSize" popper-class="user_popover" @show="getUserRank">
                <template #reference>
                    <span style="font-size: 20px;color: #fff">
                        {{userType=='designer'? userInfo.DesignerName : ''}}
                        <el-icon class="el-icon--right"><arrow-down /></el-icon>
                    </span>
                </template>

                <div class="user_pannel">
                    <el-image :src="require(`@/assets/img/UserPannel/bg_${level}.jpg`)" class="user_pannel_bg" fit="fill" />
                    <el-skeleton class="user_pannel_top" :loading="isLoading" animated>
                        <template #template>
                            <div class="userInfo">
                                <el-skeleton-item variant="image" style="width: 70px;height: 70px;border-radius: 50%;" class="user_avatar"></el-skeleton-item>
                                <div class="username">
                                    <el-skeleton-item variant="text" class="user_pannel_text_main" style="height: 45px;width: 150px;"></el-skeleton-item>
                                    <!-- <el-image :style="userBadgeSize" :src="require(`@/assets/img/UserPannel/badge_${level}.png`)"></el-image> -->
                                    <el-skeleton-item variant="text" style="height: 20px;width: 150px;"></el-skeleton-item>
                                </div>
                            </div>
                            <div class="ranking" v-if="userRank.Score>0">
                                <span>排名：</span>
                                <el-skeleton-item variant="text" class="user_pannel_text_main" style="height: 32px;width: 60px;"></el-skeleton-item>
                                <span> 名</span>
                            </div>
                        </template>
                            
                        <div class="user_pannel_top">
                            <div class="userInfo">
                                <el-avatar :size="70" class="user_avatar" style="background-color: transparent;">                                
                                    <el-image v-if="enableKJL" :src="userKJL.UserAvatar"></el-image>
                                    <el-icon v-else :size="70" color="var(--user-pannel-colour-dark)"><User /></el-icon>
                                </el-avatar>
                                <div class="username">
                                    <div class="user_pannel_text_main">{{userType=='designer'? userInfo.DesignerName : ''}}</div>
                                    <!-- <el-image :style="userBadgeSize" :src="require(`@/assets/img/UserPannel/badge_${level}.png`)"></el-image> -->
                                    <div>{{ userKJL?.UserEmail ?? $t('未绑定酷家乐账号') }}</div>
                                </div>
                            </div>
                            <div class="ranking" v-if="userRank.Score>0">
                                <span style="vertical-align: text-bottom">排名：</span>
                                <span style="vertical-align: text-bottom" class="user_pannel_text_main">{{ userRank.Ranking }}</span>
                                <span style="vertical-align: text-bottom"> 名</span>
                            </div>
                            <div class="unranking" v-else>
                                <span>您尚未上榜，快去下单吧！</span>
                            </div>
                        </div>
                    </el-skeleton>
                    <div class="user_subpannel">
                        <div class="user_grade">
                            <el-skeleton :loading="isLoading" animated>
                                <template #template>
                                    <el-skeleton-item variant="text" class="user_pannel_text_main" style="height: 18px;width: 50px;"></el-skeleton-item> 分数>
                                </template>
                                <span class="user_pannel_text_main" style="font-size: 18px;">{{ userRank.Score }}</span> 分数>
                            </el-skeleton>
                        </div>
                        <div class="user_grade_progress" :style="userProgressSize">
                            <el-image class="progress_bg" :src="require(`@/assets/img/UserPannel/progress_bg.png`)"></el-image>
                            <div class="progress_fill" :style="`width: ${userRank.Score/userRank.MaxScore*100}%;`"></div>
                            <!-- <div class="progress_tip" :style="`font-size:${userPannelHeight / 2850 * 65}px`">
                                <div style="color: #000;">V0</div>
                                <div style="color: #fff;">V3</div>
                            </div> -->
                        </div>
                        <div class="ctrl">
                            <el-link class="item" @click="onOpenShopSystem">{{$t('门店')}}</el-link>
                            <el-link class="item" @click="openHelpWebsite">{{$t('帮助')}}</el-link>
                            <el-link class="item" @click="openTecWebsite">{{$t('工艺')}}</el-link>
                            <el-link class="item" @click="onLogout">{{$t('注销')}}</el-link>
                            <!-- <el-link class="item" @click="isLoading=!isLoading">切换</el-link> -->
                        </div>
                    </div>
                </div>
            </el-popover>
            <el-dropdown @command="headerCommand">
                <span style="font-size: 20px;color: #fff">
                    {{userType=='designer'? userInfo.DesignerName : ''}}
                    <el-icon class="el-icon--right"><arrow-down /></el-icon>
                </span>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item command="crm">{{$t('门店管理系统')}}</el-dropdown-item>
                        <el-dropdown-item command="help">{{$t('帮助')}}</el-dropdown-item>
                        <el-dropdown-item command="tec">{{$t('工艺')}}</el-dropdown-item>
                        <el-dropdown-item command="logout">{{$t('注销')}}</el-dropdown-item>
                    </el-dropdown-menu>
                </template>+
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import request_d from '@/api/request_d';
import request_s from '@/api/request_s';
import tool from '@/tool/index'
export default {
	name: 'Header',
    props:{},
    components:{},
    data(){
        return{
            userPannelWidth:300,
            userPannelHeight:300,

            level:0,
            isLoading:true,
        }
    },
    computed:{        
		env(){
			return process.env.NODE_ENV
		},
		lang(){
			return this.$store.state.lang;
		},
		version(){
			return process.env.VUE_APP_VERSION
		},
        activeIndex(){
            return this.$route.path;
        },
        userInfo(){
            return this.$store.state.userInfo;
        },
        userType(){
            return this.$store.state.userType;
        },
        enableKJL(){
            return this.$store.getters.hasKJL;
        },        
        userKJL(){
            return this.$store.state.kjlInfo;
        },
        userRank(){
            return this.$store.state.userRank;
        },
        userPannelSize(){
            return `width: ${this.userPannelWidth}px;
                height: ${this.userPannelHeight}px;
                --user-pannel-colour-light:var(--user-pannel-colour-${this.level}-light);
                --user-pannel-colour-dark:var(--user-pannel-colour-${this.level}-dark);`
        },        
        userBadgeSize(){
            var width = this.userPannelWidth / 2780 * 816 *1.2;
            var height = this.userPannelHeight / 2850 * 178 *1.2;
            return `width: ${width}px;height: ${height}px;`
        },
        userProgressSize(){            
            var width = this.userPannelWidth / 2780 * 2196;
            var height = this.userPannelHeight / 2850 * 65;
            return `width: ${width}px;height: ${height}px;`
        },
    },
    watch:{},
    created(){
        // this.activeIndex=this.$route.path;
    },
    mounted(){
        // this.getUserRank();
    },
    methods:{
        getUserRank(){
            var that = this;
            var timeStamp = this.$store.state.curTime;
            // this.isLoading= true;
            request_d({
                url:'Customer/GetDesignerRanking',
                method:'POST',
                params:{
                    ts:timeStamp,
                    designerId:this.userInfo.ID
                },
                data:{
                    ciphertext: ''
                }
            }).then(({res,headers}) => {
                console.log(res);
                if (res.stateCode === 200){
                    this.$store.commit("setUserRank",res.data);
                } else {
                    this.$message.error(this.$t(res.errMsg, res.errMsgEn))
                }
            }).catch( err => {
                console.log(err);
                this.$message.error(err.message)
            }).finally(() =>{
                // that.isTableLoading=false;
                that.isLoading =false;
            })
            
        },
        headerCommand(e){
            // console.log(e);
            switch (e) {
                case 'crm':
                    this.onOpenShopSystem()
                    break;
                case 'help':
                    this.openHelpWebsite()
                    break;
                case 'tec':
                    this.openTecWebsite()
                    break;
                case 'logout':
                    this.onLogout();
                    break;
            
                default:
                    break;
            }
        },
        onChangeLanguage(){
            if (this.lang == 'zh-cn')
				this.$store.commit("setLang", 'en');
            else 
				this.$store.commit("setLang", 'zh-cn');
        },
        onOpenShopSystem(){
            var that = this;
            console.log(this.userInfo.ID);
            
            request_s({
                url:'Login/LoginFromOtherPro',
                method:'GET',
                params:{
                    id:this.userInfo.ID,
                }
            }).then(({res,headers}) => {
                console.log(res);
                if (res.success){                    
                    var urlParams = {
                        ServerStr:res.data
                    };
                    var param = tool.encodeUtf8Json(urlParams);
                    switch (that.env) {                        
                        case 'kefan':
                        case 'development':
                            var url = `https://ku.kefan.cn:8105/KfCrmHome?params=${encodeURIComponent(param)}`
                            window.open(url)                            
                            break;
                        case 'zhj':
                            var url = `https://zhj.zgkefan.cn:8205/ZhjCrmHome?params=${encodeURIComponent(param)}`
                            window.open(url)                            
                            break;
                    
                        default:
                            break;
                    }
                } else {
                    this.$message.error(res.message)
                }
            }).catch( err => {
                console.log(err);
                this.$message.error(err.message)
            }).finally(() =>{
                // that.isTableLoading=false;
            })
        },
        openHelpWebsite(){
            var that = this;
            var timeStamp = this.$store.state.curTime;
            request_d({
                url:'SampleBoard/GetKfTecStudyLoginCode',
                method:'POST',
                params:{
                    designerId:this.userInfo.ID,
                    ts:timeStamp
                },
                data:{
                    ciphertext: ""
                },
            }).then(({res,headers}) => {
                console.log(res);
                if (res.stateCode === 200){
                    window.open(`http://help.kefan.cn:8100/Login?code=${res.data}`)
                    // window.open(`http://10.10.133.2:8000/Login?code=${res.data}`)
                } else {
                    this.$message.error(this.$t(res.errMsg, res.errMsgEn))
                }
            }).catch( err => {
                console.log(err);
                this.$message.error(err.message)
            }).finally(() =>{
                // that.isTableLoading=false;
                that.isLoading=false;
            })
        },
        openTecWebsite(){
            var that = this;
            var timeStamp = this.$store.state.curTime;
            request_d({
                url:'SampleBoard/GetKfTecStudyLoginCode',
                method:'POST',
                params:{
                    designerId:this.userInfo.ID,
                    ts:timeStamp
                },
                data:{
                    ciphertext: ""
                },
            }).then(({res,headers}) => {
                console.log(res);
                if (res.stateCode === 200){
                    window.open(`https://help.kefan.cn:8101/Login?code=${res.data}`)
                } else {
                    this.$message.error(this.$t(res.errMsg, res.errMsgEn))
                }
            }).catch( err => {
                console.log(err);
                this.$message.error(err.message)
            }).finally(() =>{
                // that.isTableLoading=false;
                that.isLoading=false;
            })
            
        },
        onLogout(){
            this.$store.commit("setUserType",'');
            this.$store.commit("setUserInfo",{});
            this.$store.commit("setShopList",[]);
            this.$store.commit("clearTokens");
            // this.$router.push('/Login')
            
            location.reload(true);
        },        
        onDownloadKjlTranslatePlugin(){
            const a = document.createElement('a');
            a.style.display = 'none';
            a.setAttribute('target', '_blank');
            /*
            * download的属性是HTML5新增的属性
            * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
            * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
            * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
            */
            a.setAttribute('download', "KjlTranslatePlugin.rar");
            a.href = `/CrmApi/PlugIn/DownloadKjlTranslatePlugin?designerId=${this.userInfo.ID}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    },
}
</script>

<style scoped>
.header{
    width: 100%;
    height: 50px;
    background-color:var(--herder_colour);

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    
    --herder_colour:var(--main_colour);
    --el-menu-bg-color:var(--main_colour) !important;
    --el-menu-hover-bg-color:var(--main_colour) !important;
    --el-bg-color-overlay:var(--sub_colour) !important;
    --el-menu-active-color:var(--text_colour_1) !important;
    --el-menu-hover-text-color:var(--text_colour_1) !important;
    --el-menu-text-color:var(--text_colour_2) !important;
    --el-menu-item-font-size:16px !important;
}
.header .logo{
    width: max-content;
    height: 50px;
    padding: 5px;
    box-sizing: border-box;
    
    /* margin-left: 10px; */
    text-align: left;

    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    gap: 15px;
}
.header .logo .logotext{
    color: white;
    font-size: 25px;
    height: 40px;
    line-height: 40px;
}
.header .logo .logotext2{
    color: white;
    line-height: 30px;
    font-size: 15px;
    margin-left: -5px;
}
.header .other{    
    width: 150px;
    height: 50px;
    padding: 5px;
    box-sizing: border-box;
    /* margin-right: 10px; */
    color: white;
    font-family: '阿里妈妈东方大楷 Regular';
    font-size: 20px;
    text-decoration: underline;
    cursor: pointer;
    
    display: flex;
    align-items: flex-end;
    justify-content: space-evenly;
}
.header .user{
    width: 150px;
    height: 50px;
    padding: 5px;
    box-sizing: border-box;
    /* margin-right: 10px; */
    color: white;
    font-family: '阿里妈妈东方大楷 Regular';
    
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.header .user .user_avatar{
    border: 1px solid white;
    border-radius: 45px;
    background-color: var(--herder_colour);

    font-weight: 600 !important;
}
.header .user .user_avatar ::v-deep .el-icon{
    color: #a135b3;;
    font-size: 22px;
}
.header .menu{
    /* max-width: 50%;
    min-width: 330px; */
    flex: 1;
    height: 50px;
    font-size: 16px;
}

.user_pannel_text_main{
    font-size: 32px;
    font-family: '思源黑体 CN Bold';
    background: linear-gradient(to right, var(--user-pannel-colour-light), var(--user-pannel-colour-dark));
    background-clip: text;
    color:transparent;
}
</style>

<style>
.user_popover{
    padding: 0 !important;

    --user-pannel-colour-0-light: rgb(254,241,241);
    --user-pannel-colour-0-dark: rgb(148,76,80);
    --user-pannel-colour-1-light: rgb(255,234,224);
    --user-pannel-colour-1-dark: rgb(190,134,112);
    --user-pannel-colour-2-light: rgb(248,246,255);
    --user-pannel-colour-2-dark: rgb(154,176,197);
    --user-pannel-colour-3-light: rgb(243,235,222);
    --user-pannel-colour-3-dark: rgb(176,142,109);
    --user-pannel-colour-light:var(--user-pannel-colour-0-light);
    --user-pannel-colour-dark:var(--user-pannel-colour-0-dark);
}
.user_popover .user_pannel .user_pannel_bg{
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
}
.user_popover .user_pannel .user_pannel_top{    
    position: absolute;
    top: 0px;
    left: 5.71%;
    bottom: 37.14%;
    right: 5.71%;
    padding: 25px 15px 0px 15px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: center;
}
.user_popover .user_pannel .user_pannel_top .userInfo{  
    width: 100%;
    padding: 0px 15px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 20px;
}
.user_popover .user_pannel .user_pannel_top .userInfo .user_avatar{  

}
.user_popover .user_pannel .user_pannel_top .userInfo .username{  
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 5px
}
.user_popover .user_pannel .user_pannel_top .userInfo .username .user_badge{  
}
.user_popover .user_pannel .user_pannel_top .ranking{    
    line-height: 32px;
    font-size: 20px;
}
.user_popover .user_pannel .user_pannel_top .unranking{    
    font-size: 15px;
}
.user_popover .user_pannel .user_subpannel{    
    position: absolute;
    top: 62.86%;
    left: 5.71%;
    bottom: 7.12%;
    right: 5.71%;
    padding: 0px 18px;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
}
.user_popover .user_pannel .user_subpannel .user_grade{    

    font-size: 12px;
    color: rgb(151,151,150);
}
.user_popover .user_pannel .user_subpannel .user_grade_progress{  
    position: relative;
}
.user_popover .user_pannel .user_subpannel .user_grade_progress .progress_bg{ 
    width: 100%;
    height: 100%;
    display: block;
}
.user_popover .user_pannel .user_subpannel .user_grade_progress .progress_fill{ 
    height: 100%;
    top: 0px;
    left: 0px;
    position: absolute;
    display: block;
    background: linear-gradient(to right, var(--user-pannel-colour-light), var(--user-pannel-colour-dark));
    border-radius: 50px;
}
.user_popover .user_pannel .user_subpannel .user_grade_progress .progress_tip{
    top: -1px;
    left: 2px;
    right: 2px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    position: absolute;
    justify-content: space-between;
}
.user_popover .user_pannel .user_subpannel .ctrl{
    width: 100%;
    margin-top: 5px;
    display: grid;
    grid-template-rows: 25px 25px;
    grid-template-columns: repeat(auto-fit, minmax(50%, 1fr));
    justify-content: space-between;
    align-content: space-around;
    justify-items: center;
}
.user_popover .user_pannel .user_subpannel .ctrl .item{
    color: #fff;
    --el-link-hover-text-color:#fff;
}
</style>

